
import React, {useEffect, useState} from 'react';

import {Group, Item} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';
import {ProgressBar} from '@pb/kit-component-stepper';
import {colors} from '@pb/kit-stylus/config.json';

import type {GetData} from './typedef';
import type {Error} from 'src/openapi/admin/models/Error';


type Props<Data> = {
    chunks: number[][],
    getData: GetData<Data>,
    onDone: (data: Data[], error: Error | null) => void,
};
export const ChunkedDownloadRequestNotification = <Data, >({chunks, getData, onDone}: Props<Data>) => {
    const [data, setData] = useState<Data[]>([]);
    const [activeChunkId, setActiveChunkId] = useState(0);
    const [loadingError, setLoadingError] = useState<Error | null>(null);

    useEffect(() => {
        const loadChunks = async (chunkId: number) => {
            const prepareFileResult = await getData(chunks[chunkId]);

            if (prepareFileResult.payload.success) {
                const loadedData = prepareFileResult.payload.data;
                setData(prevState => [...prevState, ...loadedData]);
            } else {
                setLoadingError(prepareFileResult.payload.data);
            }
            setActiveChunkId(prevState => prevState + 1);
        };

        if (activeChunkId < chunks.length) {
            loadChunks(activeChunkId);
        }
    }, [activeChunkId, chunks, getData]);

    useEffect(() => {
        if (activeChunkId === chunks.length) {
            onDone(data, loadingError);
        }
    }, [activeChunkId, chunks, data, onDone, loadingError]);

    const progress = (activeChunkId / chunks.length) * 100;

    return (
        <div>
            <Label>The file generating in progress...</Label>
            <Group alignItems="center">
                <Item style={{width: 300}}>
                    <ProgressBar
                        progress={progress || 0}
                        fullColor={colors.primaryColors.skyBlueDarkest}
                        emptyColor={colors.primaryColors.gray}
                    />
                </Item>
                <Item>{Math.round(progress || 0)} %</Item>
            </Group>
        </div>
    );
};
